'use client';

import { createContext, useContext, useMemo } from 'react';
import type { GetBackgroundExecutionByToolCallId } from './hitl-types';

type BackgroundExecutionContextValue = {
  getBackgroundExecutionByToolCallId: GetBackgroundExecutionByToolCallId;
};

const BackgroundExecutionContext =
  createContext<BackgroundExecutionContextValue | null>(null);

export function BackgroundExecutionContextProvider({
  children,
  getBackgroundExecutionByToolCallId,
}: {
  children: React.ReactNode;
  getBackgroundExecutionByToolCallId: GetBackgroundExecutionByToolCallId;
}) {
  const value = useMemo(
    () => ({ getBackgroundExecutionByToolCallId }),
    [getBackgroundExecutionByToolCallId],
  );

  return (
    <BackgroundExecutionContext.Provider value={value}>
      {children}
    </BackgroundExecutionContext.Provider>
  );
}

export function useBackgroundExecution(): BackgroundExecutionContextValue | null {
  return useContext(BackgroundExecutionContext);
}
